'use client';

import Image from 'next/image';

import Button from '@/app/(football)/[team]/_components/common/Button';

interface MissionListItemProps {
  title: string;
  image: string;
  buttonText: string;
  disabled?: boolean;
  onClick?: () => void;
}

export default function MissionListItem({
  title,
  image,
  buttonText,
  disabled = false,
  onClick,
}: MissionListItemProps) {
  const imageSrcUrl = image?.startsWith('http')
    ? image
    : image
      ? `${process.env.NEXT_PUBLIC_CDN_URL}/${image}`
      : '/images/@/@img_404.svg';

  return (
    <li className="flex h-[60px] w-full items-center justify-center gap-4 rounded bg-mission-list-bg p-3 gradient-border gradient-border-mission-list">
      <div className="flex w-full items-center gap-3">
        <Image src={imageSrcUrl} alt="Mission Icon" width={38} height={38} />
        <span className="typo-body-4 line-clamp-1 flex-1 overflow-hidden text-ellipsis text-mission-list-text">
          {title}
        </span>
      </div>
      <Button
        variant="secondaryCircle"
        onClick={onClick}
        disabled={disabled}
        className="w-[82px]"
      >
        {buttonText}
      </Button>
    </li>
  );
}
